











































import { Component, Vue } from "vue-property-decorator";
import {
  MSteppers,
  MSteppersItem,
  MRadioGroup,
  MRadio,
} from "@ulaval/modul-components";
import store, { actions, modules } from "../store";
import router from "../router";
import FenetreTempsAlloueEchu from "../components/FenetreTempsAlloueEchu.vue";
import FenetreDelaiLocationDepasse from "../components/FenetreDelaiLocationDepasse.vue";
import { Etapes } from "../store/trainProgression";
import { Casier } from "../models/Casier";

@Component({
  components: {
    MSteppers,
    MSteppersItem,
    MRadioGroup,
    MRadio,
    FenetreTempsAlloueEchu,
    FenetreDelaiLocationDepasse,
  },
})
export default class TrainProgression extends Vue {
  private etapesProgression = [
    { id: Etapes[Etapes.Clientele], label: "Clientèle" },
    { id: Etapes[Etapes.Periode], label: "Période" },
    { id: Etapes[Etapes.Emplacement], label: "Emplacement" },
    { id: Etapes[Etapes.Casier], label: "Casier" },
    { id: Etapes[Etapes.Revision], label: "Révision" },
    { id: Etapes[Etapes.Paiement], label: "Paiement" },
  ];

  private obtenirEtatEtape(etapeId: string): string {
    return etapeId === this.etapeCourante ? "in-progress" : "disabled";
  }

  get etapeCourante(): string {
    return store.state.trainProgression.etapeCourante;
  }

  private async surFermetureFenetreTempsAlloueEchu() {
    store.commit(modules.minuteur.mutations.tempsAlloueEchu.name, false);

    // On s'assure de rediriger vers l'écran de sélection de casier peu
    // importe si l'utilisateur était à l'écran de révision ou de paiement.
    const route: string = await store.dispatch(
      modules.trainProgression.actions.choisirEtape.name,
      Etapes[Etapes.Casier]
    );

    router.push({ name: route });
  }

  private async surFermetureFenetreDelaiLocationDepasse() {
    this.deconnecter();
  }

  private async deconnecter(): Promise<void> {
    // On efface le state complet de l'application avant de déconnecter l'utilisateur.
    await store.dispatch(actions.effacerState.name);

    // Retrait du verrou si nécessaire
    if (this.casierUtilisateur !== null) {
      await store.dispatch(modules.cds.actions.retirerVerrouUtilisateur.name, {
        vm: this,
        idCasier: this.casierUtilisateur.id,
      });
    }

    this.$msal.logout();
  }

  private get casierUtilisateur(): Casier | null {
    return store.state.utilisateur.casier;
  }
}
